import type { AxiosInstance, AxiosResponse } from "axios";
import { composeHttpTransport } from "./http-client/composition";
import type { HttpClientDependencies, HttpRequestConfig } from "./http-client/types";

export { classifyHttpError } from "./http-client/errors";
export type { HttpErrorKind } from "./http-client/errors";

export class HttpClient {
  private readonly transport: AxiosInstance;

  constructor(dependencies: HttpClientDependencies = {}) {
    this.transport = composeHttpTransport(dependencies);
  }

  async get<T>(url: string, config?: HttpRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.transport.get(url, config);
    return response.data;
  }

  async post<T>(url: string, data?: unknown, config?: HttpRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.transport.post(url, data, config);
    return response.data;
  }

  async put<T>(url: string, data?: unknown, config?: HttpRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.transport.put(url, data, config);
    return response.data;
  }

  async patch<T>(url: string, data?: unknown, config?: HttpRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.transport.patch(url, data, config);
    return response.data;
  }

  async delete<T>(url: string, config?: HttpRequestConfig): Promise<T> {
    const response: AxiosResponse<T> = await this.transport.delete(url, config);
    return response.data;
  }
}

export const httpClient = new HttpClient();
